export enum MenuNavButtonType {
    SurfSpotList = 0,
    About
}